__turbopack_context__.v({
  "grip": "use-drawer-resize-module__o_F4oa__grip",
  "handle": "use-drawer-resize-module__o_F4oa__handle",
});
